export const PROPERTY_TYPES = {
  MEHRFAMILIENHAUS: 'Mehrfamilienhaus',
  WOHN_UND_GESCHÄFTSGEBÄUDE: 'WOHN- UND GESCHÄFTSGEBÄUDE',
};

export const LAYOUT_HEADER_TYPE = {
  TRUST_ELEMENTS: 'trustElements',
  SOCIAL_PROOF_MESSAGE: 'socialProofMessage',
  DEFAULT: 'default',
  EMPTY: '',
} as const;
